/**
 * 模块级展开状态缓存。
 *
 * react-virtuoso 滚出视口后会卸载组件，useState 随之丢失。
 * 用此 Map 在组件外部保存展开状态，重新挂载时恢复。
 */

const openMap = new Map<string, boolean>()

export function getOpen(key: string, fallback = false): boolean {
  return openMap.get(key) ?? fallback
}

export function setOpen(key: string, value: boolean): void {
  openMap.set(key, value)
}
